import Cookies from 'js-cookie'

const sessionKey = 'session'
const redirectKey = 'redirectKey'
const redirectHash = 'redirectHash'
let provider

const service = {
    authorize() {
        localStorage.setItem(redirectHash, window.location.hash)
        var oauthAuthorizeUrl = provider.buildAuthorizeUrl();
        window.location.assign(oauthAuthorizeUrl);
    },
    restoreSession() {
        var sessionString = Cookies.get(sessionKey);
        if (typeof sessionString !== 'string' || sessionString.length === 0) {
            var redirectUrl = localStorage.getItem(redirectKey);
            if (redirectUrl) {
                localStorage.removeItem(redirectKey);
                let session = provider.extractSession(redirectUrl);
                if (session && session.accessToken) {
                    let opt = { expires: 1 }
                    Cookies.set(sessionKey, session, opt);
                    let hash = localStorage.getItem(redirectHash)
                    localStorage.removeItem(redirectHash)
                    return { ...session, hash };
                }
            }
            return undefined;
        }

        let session = JSON.parse(sessionString);
        return session;
    },
    invalidateSession() {
        Cookies.remove(sessionKey);
        window.location.assign(provider.getSignOutUrl())
    },
    decodedToken() {
        let token = null
        let decodedToken = null
        token = this.getAccessToken()
        decodedToken = JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString("utf8"))

        return decodedToken
    },
    getAccessToken(resourceId) {
        var sessionString = Cookies.get(sessionKey);
        if (typeof sessionString !== 'string' || sessionString.length === 0) {
            throw new Error("You attempted to get access token for resource id: " + resourceId + " from the session but the session did not exist");
        }
        var session = JSON.parse(sessionString);
        return provider.getAccessToken(session, resourceId);
    },
    getProvider() {
        return provider;
    }
};

export default (authProvider) => {
    provider = authProvider
    return service
}
